<template>
	<div ref="popupContainer">
		<vs-popup
			:title="'Éditer les top keywords de ' + society.name"
			:active.sync="popupActive"
			style="z-index: 99999"
		>
			<!-- Import Info Popup -->
			<vs-popup
				title="Résultats de l'importation"
				:active.sync="importResultsPopup"
				style="z-index: 999991"
			>
				<div class="p-4 flex flex-col items-center">
					<div class="text-center mb-6">
						<h3 class="text-xl font-medium mb-2">Détails de l'importation</h3>
						<div class="flex flex-col space-y-2">
							<div class="flex space-x-2">
								<div class="font-medium">Total importé:</div>
								<div>{{ importStats.imported }}</div>
							</div>
							<div class="flex space-x-2">
								<div class="font-medium">Doublons ignorés:</div>
								<div>{{ importStats.duplicates }}</div>
							</div>
						</div>
					</div>
					<vs-button @click="importResultsPopup = false" class="w-1/2"
						>Fermer</vs-button
					>
				</div>
			</vs-popup>

			<vs-popup
				title="Êtes-vous sûr de vouloir supprimer ?"
				:active.sync="batchDeleteConfirmationPopup"
				style="z-index: 999991"
			>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2">
						<vs-button class="mt-2 w-full" @click="removeKeywordBatch()"
							>Oui</vs-button
						>
					</div>
					<div class="vx-col sm:w-1/2">
						<vs-button
							class="mt-2 w-full"
							@click="batchDeleteConfirmationPopup = false"
						>
							Non</vs-button
						>
					</div>
				</div>
			</vs-popup>
			<!-- Single Delete Confirmation Popup -->
			<vs-popup
				title="Êtes-vous sûr de vouloir supprimer ?"
				:active.sync="deleteConfirmationPopup"
				style="z-index: 999991"
			>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2">
						<vs-button
							class="mt-2 w-full"
							@click="removeKeyword(selectedKeywordId)"
							>Oui</vs-button
						>
					</div>
					<div class="vx-col sm:w-1/2">
						<vs-button
							class="mt-2 w-full"
							@click="deleteConfirmationPopup = false"
						>
							Non</vs-button
						>
					</div>
				</div>
			</vs-popup>

			<div>
				<div v-if="isLoading" class="text-center">
					<circular-loader />
				</div>
				<div v-else>
					<div class="keyword-editor">
						<!-- Add Keyword Input -->
						<div class="add-keyword flex flex-col space-y-4">
							<div class="flex items-center space-between w-full">
								<div class="flex justify-between items-center w-full">
									<div class="w-1/3">
										<input
											v-model="newKeyword"
											placeholder="Ajouter nouveau mots-cle..."
											@keyup.enter="addKeyword"
											class="new-keyword-input w-full"
										/>
									</div>
									<div class="flex items-center space-x-2">
										<vs-button
											color="primary"
											class="mr-2"
											@click="onClickGSCQueires()"
											>GSC</vs-button
										>
										<vs-button
											@click="onClickCategories"
											color="primary"
											type="filled"
										>
											Categories
										</vs-button>
									</div>
								</div>
							</div>

							<!-- Category-Subcategory Pairs -->
							<div v-if="newKeyword" class="category-subcategory-pairs">
								<div class="flex flex-col space-y-2">
									<!-- Add new pair button at the top -->
									<div class="flex justify-between items-center">
										<h4 class="text-lg font-medium">
											Catégories et sous-catégories
										</h4>
										<vs-button
											@click="addCategorySubcategoryPair"
											size="small"
											type="border"
											color="primary"
										>
											Ajouter une catégorie
										</vs-button>
									</div>

									<!-- List of category-subcategory pairs -->
									<div
										v-for="(pair, index) in categorySubcategoryPairs"
										:key="index"
										class="flex items-center space-x-2 py-2 border-b"
									>
										<!-- Category selector -->
										<div class="flex-1">
											<vs-select
												v-model="pair.categoryId"
												placeholder="Catégorie"
												@input="onCategoryChange(index)"
											>
												<vs-select-item
													:key="catIndex"
													:value="item.id"
													:text="item.name"
													v-for="(item, catIndex) in keywordCategories"
												/>
											</vs-select>
										</div>

										<!-- Subcategory selector - only appears once a category is selected -->
										<div class="flex-1">
											<vs-select
												v-if="
													pair.categoryId &&
													getSubcategoriesForCategory(pair.categoryId).length >
														0
												"
												v-model="pair.subcategoryId"
												placeholder="Sous-catégorie"
											>
												<vs-select-item
													:key="subIndex"
													:value="item.id"
													:text="item.name"
													v-for="(
														item, subIndex
													) in getSubcategoriesForCategory(pair.categoryId)"
												/>
											</vs-select>
											<div v-else class="text-sm text-gray-500 italic pl-2">
												{{
													pair.categoryId
														? "Pas de sous-catégories disponibles"
														: "Sélectionnez une catégorie"
												}}
											</div>
										</div>

										<!-- Remove button -->
										<div>
											<vs-button
												@click="removeCategoryPair(index)"
												type="flat"
												color="danger"
												size="small"
												icon="close"
											></vs-button>
										</div>
									</div>
									<div class="flex justify-end mt-2">
										<vs-button
											@click="addKeyword"
											color="primary"
											type="filled"
										>
											Appliquer
										</vs-button>
									</div>
								</div>
							</div>
						</div>

						<!-- CSV Import/Export -->
						<div
							class="import-csv mt-4 flex justify-between items-center w-full"
						>
							<div
								class="flex space-x-2 my-5 items-center justify-between w-full"
							>
								<div>
									<strong
										>Nombre de mots-clé affichés :
										{{ filteredKeywords.length }}</strong
									>
								</div>
								<div class="flex space-x-10 items-center">
									<div class="flex items-center space-x-2">
										<input
											type="file"
											ref="fileInput"
											style="display: none"
											accept=".xlsx, .xls"
											@change="handleCSVUpload"
										/>

										<vs-button
											@click="$refs.fileInput.click()"
											color="warning"
											type="border"
											>Import XLSX</vs-button
										>
										<a
											href="https://docs.google.com/spreadsheets/d/1ABjxDo3Zc0EFxq0B6ec8EGsQSzJiatkBkhPUsKLrU40/edit?gid=0#gid=0"
											target="_blank"
											rel="noopener noreferrer"
										>
											<vx-tooltip
												:text="'Premier ligne reservée pour les entêtes : Mots-clé, Categorie1, Sous-categorie1, Categorie2, Sous-categorie2, etc.'"
												placement="top"
											>
												<vs-icon
													icon="description"
													size="small"
													color="black"
												></vs-icon>
											</vx-tooltip>
										</a>
									</div>
									<vs-button
										icon="cloud_download"
										color="primary"
										@click="exportToExcel"
									>
										Exporter
									</vs-button>
								</div>
							</div>
						</div>

						<!-- Filters -->
						<div class="filters-section mb-4">
							<div
								class="pl-5 vx-row w-full flex space-x-5 items-center justify-space-around"
							>
								<div class="flex space-x-2 items-center">
									<div v-if="selected.length > 0">
										<vs-button
											color="danger"
											type="border"
											@click="batchDeleteConfirmationPopup = true"
										>
											Supprimer
										</vs-button>
									</div>
								</div>

								<!-- Category and Subcategory Filters -->
							</div>
						</div>

						<!-- Keyword Table -->
						<vs-table
							multiple
							v-model="selected"
							pagination
							max-items="30"
							search
							:data="filteredKeywords"
						>
							<template slot="header">
								<div class="category-filter flex">
									<div class="flex space-x-2 items-center">
										<!-- Category filter -->
										<vs-select
											v-model="selectedCategoryFilters"
											multiple
											placeholder="Filtrer par catégorie"
											@input="onFilterCategoryChange"
										>
											<vs-select-item
												:key="index"
												:value="item.id"
												:text="item.name"
												v-for="(item, index) in keywordCategories"
											/>
										</vs-select>

										<!-- Subcategory filter - shows only when categories are selected -->
										<vs-select
											v-if="
												selectedCategoryFilters &&
												selectedCategoryFilters.length > 0 &&
												availableSubcategoriesForFilter.length > 0
											"
											v-model="selectedSubcategoryFilters"
											multiple
											placeholder="Filtrer par sous-catégorie"
											class="w-1/2"
										>
											<vs-select-item
												:key="index"
												:value="item.id"
												:text="item.name"
												v-for="(item, index) in availableSubcategoriesForFilter"
											/>
										</vs-select>
									</div>

									<!-- Reset filters button -->
									<div
										v-if="
											selectedCategoryFilters.length > 0 ||
											selectedSubcategoryFilters.length > 0
										"
										class="mt-2 flex justify-end items-center"
									>
										<vx-tooltip
											text="Effacer les filtres"
											position="top"
											style="
												text-align: -webkit-center;
												margin-right: 0 !important;
											"
										>
											<vs-button
												class="ml-2"
												type="line"
												style="border: 0px"
												@click="clearFilters"
												color="danger"
												icon="clear"
											></vs-button>
										</vx-tooltip>
									</div>
								</div>
							</template>
							<template slot="thead">
								<vs-th style="pointer-events: auto" sort-key="keyword">
									Requête
								</vs-th>
								<vs-th style="pointer-events: auto" sort-key="categories">
									Catégories > Sous catégories
								</vs-th>
								<vs-th sort-key=""> Actions </vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
									<!-- Keyword column -->
									<vs-td :data="data[indextr].keyword">
										<div v-if="data[indextr].isEditing">
											<input
												v-model="data[indextr].editKeyword"
												class="edit-input"
												@keyup.enter="saveEdit(data[indextr])"
											/>
										</div>
										<div v-else>
											{{ data[indextr].keyword }}
										</div>
									</vs-td>

									<!-- Categories & Subcategories column -->
									<vs-td :data="data[indextr].keyword">
										<div v-if="data[indextr].isEditing">
											<div
												v-for="(pair, pairIndex) in data[indextr]
													.editCategoryPairs"
												:key="pairIndex"
												class="edit-category-pair flex items-center space-x-2 mb-2"
											>
												<!-- Category selector -->
												<vs-select
													v-model="pair.categoryId"
													placeholder="Catégorie"
													class="flex-1"
													@input="
														onEditCategoryChange(data[indextr], pairIndex)
													"
												>
													<vs-select-item
														:key="catIndex"
														:value="item.id"
														:text="item.name"
														v-for="(item, catIndex) in keywordCategories"
													/>
												</vs-select>

												<!-- Subcategory selector -->
												<vs-select
													v-if="
														pair.categoryId &&
														getSubcategoriesForCategory(pair.categoryId)
															.length > 0
													"
													v-model="pair.subcategoryId"
													placeholder="Sous-catégorie"
													class="flex-1"
												>
													<vs-select-item
														:key="subIndex"
														:value="item.id"
														:text="item.name"
														v-for="(
															item, subIndex
														) in getSubcategoriesForCategory(pair.categoryId)"
													/>
												</vs-select>
												<div
													v-else
													class="flex-1 text-sm text-gray-500 italic pl-2"
												>
													{{
														pair.categoryId
															? "Pas de sous-catégories"
															: "Choisir une catégorie"
													}}
												</div>

												<!-- Remove button -->
												<vs-button
													@click="
														removeEditCategoryPair(data[indextr], pairIndex)
													"
													type="flat"
													size="small"
													icon="close"
													class="flex-none"
												></vs-button>
											</div>

											<!-- Add pair button -->
											<vs-button
												@click="addEditCategoryPair(data[indextr])"
												size="small"
												type="border"
											>
												+ Ajouter une catégorie
											</vs-button>
										</div>
										<div v-else class="category-chips">
											<div
												v-for="(pair, pairIndex) in getKeywordCategoryPairs(
													data[indextr]
												)"
												:key="pairIndex"
												class="mb-2"
											>
												<vs-chip class="mr-1">
													{{ getCategoriesName(pair.categoryId) }}
													{{
														getSubcategoryName(pair.subcategoryId)
															? " > " + getSubcategoryName(pair.subcategoryId)
															: ""
													}}
												</vs-chip>
												<!-- <vs-chip
													v-if="pair.subcategoryId"
													class="mr-1 subcategory-chip"
												>
													{{}}
												</vs-chip> -->
											</div>
										</div>
									</vs-td>

									<!-- Actions column -->
									<vs-td :data="data[indextr].keyword" class="flex-actions">
										<vs-icon
											v-if="data[indextr].isEditing"
											icon="save"
											size="small"
											color="success"
											class="action-icon"
											@click.stop="saveEdit(data[indextr])"
										></vs-icon>
										<vs-icon
											v-else
											icon="edit"
											size="small"
											color="primary"
											class="action-icon"
											@click.stop="startEdit(data[indextr])"
										></vs-icon>
										<vs-icon
											icon="delete"
											size="small"
											color="danger"
											class="action-icon"
											@click.stop="onRemoveClick(data[indextr].id)"
										></vs-icon>
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>
  
<script>
import Vue from "vue";
import XLSX from "xlsx";
import Keywords from "@/entities/Keywords";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import KeywordCategoriesPopup from "./KeywordCategoriesPopup.vue";
import store from "@/store/store";
import VxTooltip from "../widgets/vx-tooltip/VxTooltip.vue";
import GSCQueriesPopup from "./GSCQueriesPopup.vue";

export default {
	components: { CircularLoader, KeywordCategoriesPopup, VxTooltip },
	name: "KeywordManager",
	props: {
		society: {
			type: Object,
			required: true,
		},
		popupActive: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			keywords: [], // local copy to manipulate
			selected: [], // selected keywords for deletion

			// For new keywords
			categorySubcategoryPairs: [],

			// For filtering
			selectedCategoryFilters: [],
			selectedSubcategoryFilters: [],

			// Data lists
			keywordsFullChips: [], // full list of keywords
			keywordsChips: [], // filtered list of keywords
			subcategories: [], // List of all subcategories
			keywordsChipsKey: 0,

			// Form fields
			newKeyword: "",
			newKeywordComment: "",
			nextId: 1,

			// UI states
			isLoading: false,
			searchQuery: "",
			showCategoriesPopup: false,
			batchDeleteConfirmationPopup: false,
			deleteConfirmationPopup: false,
			selectedKeywordId: null,

			importResultsPopup: false,
			importStats: {
				imported: 0,
				duplicates: 0,
			},
		};
	},
	async created() {
		// Clone initial data and track max ID
		await this.refreshData();

		// Initialize with one empty category pair
		this.addCategorySubcategoryPair();
	},
	computed: {
		keywordCategories() {
			return store.state.keywordsCategories;
		},

		// Get available subcategories for the filter
		availableSubcategoriesForFilter() {
			if (
				!this.selectedCategoryFilters ||
				this.selectedCategoryFilters.length === 0
			) {
				return [];
			}

			return this.subcategories.filter((subcategory) =>
				this.selectedCategoryFilters.includes(subcategory.category_id)
			);
		},

		filteredKeywords() {
			let result = this.keywordsChips;

			// Filter by category if selected
			if (
				this.selectedCategoryFilters &&
				this.selectedCategoryFilters.length > 0
			) {
				result = result.filter((keyword) => {
					// Get all category pairs for this keyword
					const pairs = this.getKeywordCategoryPairs(keyword);

					// Check if any pair has a category that matches the filter
					return pairs.some((pair) =>
						this.selectedCategoryFilters.includes(pair.categoryId)
					);
				});
			}

			// Filter by subcategory if selected
			if (
				this.selectedSubcategoryFilters &&
				this.selectedSubcategoryFilters.length > 0
			) {
				result = result.filter((keyword) => {
					// Get all category pairs for this keyword
					const pairs = this.getKeywordCategoryPairs(keyword);

					// Check if any pair has a subcategory that matches the filter
					return pairs.some(
						(pair) =>
							pair.subcategoryId &&
							this.selectedSubcategoryFilters.includes(pair.subcategoryId)
					);
				});
			}

			return result;
		},
	},
	watch: {
		searchQuery: {
			immediate: false,
			handler(query) {
				if (!query) {
					this.keywordsChips = this.keywordsFullChips;
				} else {
					this.keywordsChips = this.keywordsFullChips.filter((chip) =>
						chip.keyword.toLowerCase().includes(query.toLowerCase())
					);
				}
			},
		},
		keywordsFullChips: {
			immediate: true,
			handler(data) {
				this.keywordsChips = data;
				const maxId = data.reduce((max, k) => (k.id > max ? k.id : max), 0);
				this.nextId = maxId + 1;
			},
		},
	},
	methods: {
		async refreshData() {
			await this.getKeywordCategories();
			await this.getSubcategories(); // Get subcategories data
			await this.getTopKeywords();
		},
		onClickGSCQueires() {
			try {
				if (
					this.$props.society.gsc_url == null ||
					this.$props.society.gsc_url == ""
				) {
					this.$vs.notify({
						title: "Erreur",
						color: "danger",
						text: "Veuillez d'abord renseigner l'url de la search console",
					});
					return;
				} else {
					this.showTopKeywordsPopup = true;
					let ComponentClass = Vue.extend(GSCQueriesPopup);
					let gscQueriesPopup = new ComponentClass({
						propsData: {
							// initialKeywords: this.topKeywords,
							society: this.$props.society || {}, // Évite undefined
							popupActive: this.showTopKeywordsPopup,
						},
					});

					gscQueriesPopup.$mount();

					// Vérification de popupContainer avant l'ajout
					if (this.$refs.popupContainer) {
						this.$refs.popupContainer.appendChild(gscQueriesPopup.$el);
					} else {
						console.error("popupContainer non trouvé");
					}

					gscQueriesPopup.$on("close-popup", () => {
						this.showTopKeywordsPopup = false;
					});
				}
			} catch (e) {
				console.error(e);
				this.$vs.notify({
					title: "Erreur",
					color: "danger",
					text: "Une erreur est survenue lors de l'ouverture du popup",
				});
			}
		},
		// Add a new category-subcategory pair to the form
		addCategorySubcategoryPair() {
			this.categorySubcategoryPairs.push({
				categoryId: null,
				subcategoryId: null,
			});
		},

		// Remove a category-subcategory pair from the form
		removeCategoryPair(index) {
			if (this.categorySubcategoryPairs.length > 1) {
				this.categorySubcategoryPairs.splice(index, 1);
			} else {
				// If it's the last pair, just reset it
				this.categorySubcategoryPairs[0] = {
					categoryId: null,
					subcategoryId: null,
				};
			}
		},

		// Add a category pair to an item being edited
		addEditCategoryPair(keyword) {
			if (!keyword.editCategoryPairs) {
				this.$set(keyword, "editCategoryPairs", []);
			}

			keyword.editCategoryPairs.push({
				categoryId: null,
				subcategoryId: null,
			});
		},

		// Remove a category pair from an item being edited
		removeEditCategoryPair(keyword, index) {
			if (keyword.editCategoryPairs.length > 1) {
				keyword.editCategoryPairs.splice(index, 1);
			}
		},

		// Convert category_pairs string to array of pairs
		// Convert category_pairs string to array of pairs with normalized property names
		getKeywordCategoryPairs(keyword) {
			if (!keyword.category_pairs) {
				return [];
			}

			let pairs = [];

			if (typeof keyword.category_pairs === "string") {
				try {
					pairs = JSON.parse(keyword.category_pairs);
				} catch (e) {
					console.error("Error parsing category_pairs:", e);
					return [];
				}
			} else {
				pairs = keyword.category_pairs || [];
			}

			// Normalize property names (handle both formats) and preserve id
			return pairs.map((pair) => {
				return {
					id: pair.id, // Preserve the mapping ID
					categoryId: pair.categoryId || pair.category_id,
					subcategoryId: pair.subcategoryId || pair.subcategory_id,
				};
			});
		},

		// Reset all filters
		clearFilters() {
			this.selectedCategoryFilters = [];
			this.selectedSubcategoryFilters = [];
		},

		// When filter categories change, reset subcategory filter
		onFilterCategoryChange() {
			this.selectedSubcategoryFilters = [];
		},

		// When a category is changed in the form
		onCategoryChange(index) {
			// Reset subcategory when category changes
			this.categorySubcategoryPairs[index].subcategoryId = null;
		},

		// When a category is changed during edit
		onEditCategoryChange(keyword, index) {
			// Reset subcategory when category changes during edit
			keyword.editCategoryPairs[index].subcategoryId = null;
		},

		// Get subcategories for a given category ID
		getSubcategoriesForCategory(categoryId) {
			if (!categoryId) return [];

			return this.subcategories.filter(
				(subcategory) => subcategory.category_id === categoryId
			);
		},

		// Get subcategories data
		async getSubcategories() {
			try {
				this.isLoading = true;
				// Replace with your actual API call to get subcategories
				const subcategories = await Keywords.getKeywordsSubcategories();
				this.subcategories = subcategories || [];
				this.isLoading = false;
			} catch (error) {
				this.$vs.notify({
					title: "Error",
					text: "Failed to fetch subcategories",
					color: "danger",
				});
				console.error(error);
				this.isLoading = false;
			}
		},

		// Start edit mode
		startEdit(keyword) {
			// Set editing flags and prepare edit values
			this.$set(keyword, "isEditing", true);
			this.$set(keyword, "editKeyword", keyword.keyword);

			// Convert category_pairs to editCategoryPairs
			const pairs = this.getKeywordCategoryPairs(keyword);

			// Make sure to preserve the id (mapping_id) when preparing for edit
			this.$set(
				keyword,
				"editCategoryPairs",
				pairs.map((pair) => ({
					id: pair.id, // Preserve the mapping ID
					categoryId: pair.categoryId,
					subcategoryId: pair.subcategoryId,
				}))
			);

			// If no pairs exist, add one empty pair
			if (keyword.editCategoryPairs.length === 0) {
				this.addEditCategoryPair(keyword);
			}
		},

		async saveEdit(keyword) {
			try {
				const trimmedKeyword = keyword.editKeyword.trim();
				if (!trimmedKeyword) {
					this.$vs.notify({
						title: "Erreur",
						text: "Le mot-clé ne peut pas être vide",
						color: "warning",
					});
					return;
				}

				// Filter out incomplete pairs
				const validPairs = keyword.editCategoryPairs.filter(
					(pair) => pair.categoryId !== null
				);

				// Convert categoryId/subcategoryId to category_id/subcategory_id format
				const convertedPairs = validPairs.map((pair) => ({
					id: pair.id || null, // Include id if available
					keyword_id: keyword.id,
					category_id: pair.categoryId,
					subcategory_id: pair.subcategoryId,
				}));

				const updateData = {
					keyword: trimmedKeyword,
					id: keyword.id,
					category_pairs: JSON.stringify(convertedPairs),
				};

				await Keywords.updateTopKeyword(updateData, keyword.id);

				// Update local data
				keyword.keyword = trimmedKeyword;
				keyword.category_pairs = validPairs; // Keep frontend format for local data
				keyword.isEditing = false;

				this.$vs.notify({
					title: "Succès",
					text: "Mot-clé mis à jour avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la mise à jour du mot-clé",
					color: "danger",
				});
				console.error(error);
			}
		},

		onClickCategories() {
			this.showCategoriesPopup = true;
			let ComponentClass = Vue.extend(KeywordCategoriesPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					popupActive: this.showCategoriesPopup,
					zIndex: 99999,
				},
			});
			contractPopup.$mount();
			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		getCategoriesName(id) {
			if (!id) return "";
			const category = this.keywordCategories.find((cat) => cat.id === id);
			return category ? category.name : "Unknown";
		},

		getSubcategoryName(id) {
			if (!id) return "";
			const subcategory = this.subcategories.find((sub) => sub.id === id);
			return subcategory ? subcategory.name : "Unknown";
		},

		async getTopKeywords() {
			try {
				this.isLoading = true;
				let keywords = await Keywords.getTopKeywords(this.$props.society.id);

				// Add editing flags to all keywords
				keywords = keywords.map((keyword) => ({
					...keyword,
					isEditing: false,
					editKeyword: "",
					editCategoryPairs: [],
				}));

				this.keywords = keywords;
				this.keywordsFullChips = keywords.reverse();
				this.keywordsChips = this.keywordsFullChips;
				this.keywordsChipsKey++;
				this.isLoading = false;
			} catch (error) {
				this.$vs.notify({
					title: "Error",
					text: "Failed to fetch keywords",
					color: "danger",
				});
				console.error(error);
				this.isLoading = false;
			}
		},

		async getKeywordCategories() {
			try {
				this.isLoading = true;
				store.dispatch("fetchKeywordCategories").then((result) => {
					this.keywordCategories = result;
				});
				this.isLoading = false;
			} catch (error) {
				this.$vs.notify({
					title: "Error",
					text: "Failed to fetch keyword categories",
					color: "danger",
				});
				console.error(error);
				this.isLoading = false;
			}
		},

		async addKeyword() {
			try {
				const trimmed = this.newKeyword.trim();
				if (!trimmed) return;

				// Filter out incomplete pairs
				const validPairs = this.categorySubcategoryPairs.filter(
					(pair) => pair.categoryId !== null
				);

				// Convert categoryId/subcategoryId to category_id/subcategory_id format
				const convertedPairs = validPairs.map((pair) => ({
					category_id: pair.categoryId,
					subcategory_id: pair.subcategoryId,
				}));

				let newKeyword = {
					id: this.nextId++,
					society_id: this.$props.society.id || null,
					keyword: trimmed,
					comment: this.newKeywordComment,
					category_pairs: JSON.stringify(convertedPairs),
					search_lang: "fr-fr",
					search_location: "Paris,Paris,Ile-de-France,France",
					search_engine: "google",
					isEditing: false,
				};

				const response = await Keywords.addTopKeywords(
					[newKeyword],
					this.$props.society.id
				);

				this.keywordsFullChips = response.concat(this.keywordsFullChips);
				this.keywordsChipsKey++;

				// Reset form
				this.newKeyword = "";
				this.newKeywordComment = "";
				this.categorySubcategoryPairs = [
					{ categoryId: null, subcategoryId: null },
				];
				await this.getTopKeywords();
				this.$vs.notify({
					title: "Succès",
					text: "Mot-clé ajouté avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Error",
					text: "Failed to add keyword",
					color: "danger",
				});
				console.error(error);
			}
		},
		onRemoveClick(id) {
			this.deleteConfirmationPopup = true;
			this.selectedKeywordId = id;
		},

		async removeKeyword(id) {
			try {
				await Keywords.deleteTopKeywords(id);
				this.keywordsFullChips = this.keywordsFullChips.filter(
					(k) => k.id !== id
				);
				this.deleteConfirmationPopup = false;
				this.selectedKeywordId = null;

				this.$vs.notify({
					title: "Succès",
					text: "Mot-clé supprimé avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Echec",
					text: "Échec de la suppression du mot-clé",
					color: "danger",
				});
				console.error(error);
			}
		},

		async removeKeywordBatch() {
			try {
				let ids = this.selected.map((k) => k.id);
				if (ids.length === 0) return;

				await Keywords.deleteTopKeywordsBatch(ids);

				this.keywordsFullChips = this.keywordsFullChips.filter(
					(k) => !ids.includes(k.id)
				);

				this.$vs.notify({
					title: "Succès",
					text: "Mots-clés supprimés avec succès",
					color: "success",
				});

				this.selected = []; // Clear selected keywords after deletion
				this.batchDeleteConfirmationPopup = false;
			} catch (error) {
				this.$vs.notify({
					title: "Echec",
					text: "Échec de la suppression des mots-clés",
					color: "danger",
				});
				console.error(error);
			}
		},

		// Function to check if keyword already exists
		isKeywordDuplicate(keyword) {
			return this.keywordsFullChips.some(
				(k) => k.keyword.toLowerCase() === keyword.toLowerCase()
			);
		},

		handleCSVUpload(event) {
			const file = event.target.files[0];
			if (!file) return;

			const fileExtension = file.name.split(".").pop().toLowerCase();
			if (fileExtension !== "xlsx" && fileExtension !== "xls") {
				this.$vs.notify({
					title: "Erreur",
					text: "Seuls les fichiers Excel (XLSX/XLS) sont pris en charge",
					color: "danger",
				});
				return;
			}

			const reader = new FileReader();

			reader.onload = async (e) => {
				try {
					let newKeywords = [];
					let rows = [];
					const result = e.target.result;

					const data = new Uint8Array(result);
					const workbook = XLSX.read(data, { type: "array" });
					const sheet = workbook.Sheets[workbook.SheetNames[0]];
					rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

					let duplicateCount = 0;

					rows.slice(1).forEach((row) => {
						const keyword = row[0] ? row[0].toString().trim() : "";
						if (!keyword) return;

						if (this.isKeywordDuplicate(keyword)) {
							duplicateCount++;
							return;
						}

						const categoryString = row[1] ? row[1].toString().trim() : "";
						const pairs = [];

						if (categoryString) {
							const categoryPairs = categoryString
								.split(",")
								.map((p) => p.trim());
							categoryPairs.forEach((pairStr) => {
								const parts = pairStr.split(">").map((p) => p.trim());
								const categoryName = parts[0] || "";
								const subcategoryName = parts.length > 1 ? parts[1] : "";

								let pair = {};

								if (categoryName) {
									const matchedCategory = this.keywordCategories.find(
										(cat) =>
											cat.name.toLowerCase() === categoryName.toLowerCase()
									);
									if (matchedCategory) {
										pair.category_id = matchedCategory.id;
									}
									pair.category_name = categoryName;
								}

								if (subcategoryName) {
									const matchedSubcategory = this.subcategories.find(
										(sub) =>
											sub.name.toLowerCase() ===
												subcategoryName.toLowerCase() &&
											pair.category_id === sub.category_id
									);
									if (matchedSubcategory) {
										pair.subcategory_id = matchedSubcategory.id;
									}
									pair.subcategory_name = subcategoryName;
								}

								// ✅ Only push if pair has at least 1 valid property
								if (Object.keys(pair).length > 0) {
									pairs.push(pair);
								}
							});
						}

						newKeywords.unshift({
							id: this.nextId++,
							society_id: this.$props.society.id || null,
							keyword: keyword,
							category_pairs: JSON.stringify(pairs),
							search_lang: "fr-fr",
							search_location: "Paris,Paris,Ile-de-France,France",
							search_engine: "google",
							isEditing: false,
						});
					});

					this.importStats.imported = newKeywords.length;
					this.importStats.duplicates = duplicateCount;
					this.importResultsPopup = true;

					if (newKeywords.length > 0) {
						const response = await Keywords.addTopKeywords(
							newKeywords,
							this.$props.society.id
						);
						this.keywordsFullChips = response.concat(this.keywordsFullChips);
						this.keywordsChipsKey++;

						let message = `${newKeywords.length} mots-clés importés avec succès`;
						if (duplicateCount > 0) {
							message += `, ${duplicateCount} doublons ignorés`;
						}

						this.$vs.notify({
							title: "Succès",
							text: message,
							color: "success",
						});
						this.refreshData();
					} else if (duplicateCount > 0) {
						this.$vs.notify({
							title: "Information",
							text: `Aucun nouveau mot-clé importé, ${duplicateCount} doublons ignorés`,
							color: "primary",
						});
					} else {
						this.$vs.notify({
							title: "Information",
							text: "Aucun mot-clé à importer",
							color: "primary",
						});
					}

					this.$refs.fileInput.value = "";
				} catch (error) {
					this.$vs.notify({
						title: "Echec",
						text: "Échec de l'importation des mots-clés",
						color: "danger",
					});
					console.error(error);
				}
			};

			reader.readAsArrayBuffer(file);
		},
		exportToExcel() {
			try {
				// Prepare data for export
				const dataToExport = this.keywordsChips.map((item) => {
					// Get category pairs
					const pairs = this.getKeywordCategoryPairs(item);

					// Format categories and subcategories in a single column
					const categoriesString = pairs
						.map((pair) => {
							const categoryName = pair.categoryId
								? this.getCategoriesName(pair.categoryId)
								: "";
							const subcategoryName = pair.subcategoryId
								? this.getSubcategoryName(pair.subcategoryId)
								: "";

							// Format as "category > subcategory" or just "category" if no subcategory
							return subcategoryName
								? `${categoryName} > ${subcategoryName}`
								: categoryName;
						})
						.join(", ");

					// Create export row with only two columns
					const exportRow = {
						"Mots-clé": item.keyword,
						Catégories: categoriesString,
					};

					return exportRow;
				});

				const worksheet = XLSX.utils.json_to_sheet(dataToExport);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, "Mots-clés");

				XLSX.writeFile(workbook, "export_mots_cles.xlsx");

				this.$vs.notify({
					title: "Succès",
					text: "Mots-clés exportés avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Echec",
					text: "Échec de l'exportation des mots-clés",
					color: "danger",
				});
				console.error(error);
			}
		},
	},
};
</script>
  
<style scoped>
.keyword-editor {
	padding: 20px;
}
.add-keyword input {
	padding: 10px;
	margin-right: 10px;
	border: 1px solid #ccc;
}
.new-keyword-input {
	width: 30%;
}
.category-subcategory-pairs {
	margin-top: 15px;
	border: 1px solid #eee;
	border-radius: 5px;
	padding: 15px;
	background-color: #f9f9f9;
}
.chips-wrapper {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
.edit-input {
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 4px;
	width: 100%;
}
.flex-actions {
	display: flex;
	gap: 10px;
}
.action-icon {
	cursor: pointer;
}
.category-filter {
	margin-bottom: 15px;
	width: 100%;
}
.filters-section {
	margin-top: 20px;
}
.subcategory-chip {
	background-color: #f0f0f0 !important;
	margin-left: 15px;
	position: relative;
}
.subcategory-chip::before {
	content: "→";
	position: absolute;
	left: -12px;
	color: #999;
}
.edit-category-pair {
	border-bottom: 1px solid #eee;
	padding-bottom: 8px;
}
</style>